import React from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

export const ChristmasFrame: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const currentYear = moment().year();

    const christmasCountDown =
        moment(`${currentYear}-12-25`).diff(moment(), 'days') + 1;

    const label =
        christmasCountDown > 0
            ? t('Messages.ChristmasCountDown').replace(
                  '{days}',
                  christmasCountDown.toString()
              )
            : t('Messages.Christmas');

    return (
        <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" justifyContent="center" mb={3}>
                <Typography
                    variant="body2"
                    color="textPrimary"
                    style={{ color: theme.palette.primary.main }}
                >
                    ꧁ ⋆꙳•̩̩͙❅*̩̩͙‧͙ <span>🎄</span> <big>🎅🏻</big> <span>🎄</span> ‧͙*̩̩͙❆ ͙͛
                    ˚₊⋆ ꧂
                </Typography>
            </Box>
            <Box mb={1}>{children}</Box>
            <Box display="flex" justifyContent="center" mb={2}>
                <Typography align="center" variant="body2" color="textPrimary">
                    <small>🎁</small> {label}
                </Typography>
            </Box>
            <Box display="flex" justifyContent="center" mb={2}>
                <Typography
                    variant="h4"
                    align="center"
                    style={{ color: theme.palette.info.main, letterSpacing: 5 }}
                >
                    ⋆꙳•̩̩͙❅*̩̩͙‧͙ ‧͙*̩̩͙❆ ͙͛ ˚₊⋆
                </Typography>
            </Box>
        </Box>
    );
};
